import '../../components/advantages';
import '../../components/contacts';
import '../../components/form/input';
import '../../sections/compare';
import '../../sections/contacts';
import '../../sections/contacts-page';
import '../../sections/footer';
import '../../sections/full-nav';
import '../../sections/header';
import '../../sections/infrastructure';
import '../../sections/mortgage';
import '../../sections/news-detail';
import '../../sections/developer-roadmap-map';
import '../../sections/format-life';
import '../../sections/sticky-btn';
import '../../sections/opk';
import {
    initAccordions,
    initBindedSelects,
    initButtonShare,
    initCallbackPopup,
    initCombiningWidgets, initCompareButton, initCompareList, initComparePopups, initCompareState,
    initFavoriteButton, initFavoritesList,
    initFavoriteState,
    initFlatType,
    initForm,
    initHorizontalMenu,
    initMindboxManager, initMortgageAccordions,
    initMortgageTabs,
    initNewsList,
    initObjectSlider,
    initOpkForm,
    initParallaxColumn,
    initParametric,
    initPopup, initPostMessagePopup,
    initProgress,
    initPromotionTerms,
    initShare,
    initStickyButton,
    initSwiperAcceptanceStepsSlider,
    initSwiperActionsSlider,
    initSwiperCarouselSlider,
    initSwiperCarouselSliderOneItem,
    initSwiperComparelSlider,
    initSwiperFlatsSlider,
    initSwiperProposalAdvantages,
    initSwiperRelatedSlider,
    initSwiperSlider,
    initSwiperVerticalSlider,
    initTabs,
    initTabsInner,
    initToggle,
    initTradeInForm,
    initTrustServicePopup,
    lazyLoadElements,
    stepBack
} from './common';
import {Accordion} from '../../components/accordion';
import CookiesNotice from '../../components/cookies-notice';
import CustomSelect from '../../components/form/custom-select';
import DetailsAccordion from '../../components/details';
import FinishesTable from '../../components/finishes-table';
import Observer from './observer';
import ScrollBy from '../../components/scrollBy';
import {throttle} from 'throttle-debounce';

const observer = new Observer();

// Расчёт vh - костыль для корректной работы мобильного меню
const appHeight = () => {
    const vh = window.innerHeight * 0.01;

    document.documentElement.style.setProperty('--vh', `${vh}px`);
};

appHeight();

// Expose current path for page-scoped styles on frontend.
const pagePath = window.location.pathname.replace(/^\/|\/$/gu, '') || 'home';

document.body.setAttribute('data-page', pagePath);

// Шапка
const headerWrap = document.querySelector('.j-header');

// Cкролл по якорям
const anchors = Array.from(document.querySelectorAll('.j-anchor'));

if (anchors.length) {
    const scrollBy = new ScrollBy();

    scrollBy.init({
        takeElements: [headerWrap],
        anchors
    });
}

// Попапы с видео в аккордионе
const popupAccordionVideo = Array.from(document.querySelectorAll('.j-accordion-video'));

if (popupAccordionVideo.length) {
    initPopup(popupAccordionVideo, {modify: 'popup_theme_video'});
}

// Инициализируем аккордеон с вопросами
const questions = document.querySelector('.j-questions-accordion');

if (questions) {
    const showAll = document.querySelector('.j-questions-all');
    const questionsAccordion = new Accordion();

    questionsAccordion.init(questions);

    if (showAll) {
        showAll.addEventListener('click', () => {
            questionsAccordion.toggle();
        });
    }
}

/* Ленивая загрузка */
const lazyElements = Array.from(document.querySelectorAll('[loading=lazy]'));

if (lazyElements.length) {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            lazyLoadElements(lazyElements);
        });
    } else {
        lazyLoadElements(lazyElements);
    }
}

observer.subscribe('lazyLoad:refresh', (container) => {
    const secLazyElements = Array.from(container.querySelectorAll('[loading=lazy]'));

    lazyLoadElements(secLazyElements);
});

// Плавный подскролл по якорям
const simpleAnchors = Array.from(document.querySelectorAll(`a[href^="#"]:not(.j-anchor)`));

simpleAnchors.forEach((anchor) => {
    if (anchor.getAttribute('href').length === 1) {
        return;
    }

    const anchorBlock = document.querySelector(anchor.getAttribute('href'));

    if (anchorBlock) {
        anchor.addEventListener('click', (event) => {
            event.preventDefault();

            anchorBlock.scrollIntoView({
                behavior: 'smooth'
            });
        });
    }
});

// Отображение плавающей кнопки возврата вверх
const checkAnchorScroll = () => {
    const anchor = document.querySelector('.j-anchor');

    if (anchor) {
        const sentinel = document.createElement('div');

        sentinel.style.position = 'absolute';
        sentinel.style.top = '100vh';
        sentinel.style.width = '1px';
        sentinel.style.height = '1px';
        document.body.appendChild(sentinel);

        const anchorObserver = new IntersectionObserver((entries) => {
            const isBelowViewport = !entries[0].isIntersecting;

            anchor.classList.toggle('is-scrolled', isBelowViewport);
            anchor.classList.toggle('is-active', isBelowViewport);
        });

        anchorObserver.observe(sentinel);
    }
};

checkAnchorScroll();

// Табы
const tabs = Array.from(document.querySelectorAll('.j-tabs-wrap'));

tabs.forEach((elem) => {
    initTabs(elem);
});

const tabsInner = Array.from(document.querySelectorAll('.j-tabs-inner-wrap'));

tabsInner.forEach((tab) => {
    const options = {
        elem          : tab,
        tabsParent    : '.j-tabs-inner',
        tabItem       : '.j-tabs__item-inner',
        contentsParent: '.j-tabs-content-inner',
        contentItem   : '.j-tabs-content__item-inner'
    };

    initTabsInner(options);
});

observer.subscribe('tabs:refresh', (container) => {
    if (!container) {
        return;
    }

    const refreshedTabs = Array.from(container.querySelectorAll('.j-tabs-wrap'));

    refreshedTabs.forEach((elem) => {
        initTabs(elem);
    });
});

// Таблица сравнения видов отделки
const finishesTables = [...document.querySelectorAll('.j-finishes-table')];

finishesTables.forEach((table) => {
    const finishesTableInstance = new FinishesTable();

    finishesTableInstance.init({
        table
    });
});

// Аккордеон
const accordions = Array.from(document.querySelectorAll('.j-accordion'));

accordions.forEach((accordion) => {
    initAccordions(accordion);
});

// Details Accordion
const details = [...document.querySelectorAll('.j-details')];

details.forEach((element) => {
    const accordion = new DetailsAccordion();

    accordion.init({
        element
    });
});

// Mortgage Accordions
const mortgageAccordions = Array.from(document.querySelectorAll('.j-mortgage-accordion'));

mortgageAccordions.forEach((acc) => {
    initMortgageAccordions(acc);
});

// Формы
const formWrappers = Array.from(document.querySelectorAll('.j-form'));

formWrappers.forEach((wrapper) => {
    initForm(wrapper);
});

const tradeInFormWrappers = Array.from(document.querySelectorAll('.j-trade-in-form'));

tradeInFormWrappers.forEach((wrapper) => {
    initTradeInForm(wrapper);
});

// Попапы
const initDefaultPopups = (container) => {
    const wrapper = container ? container : document;
    const popupSelectors = [...wrapper.querySelectorAll('.j-popup:not([data-init])')];

    if (popupSelectors.length) {
        initPopup(popupSelectors, {removeDelay: 300});
        popupSelectors.forEach((element) => {
            element.dataset.init = 'true';
        });
    }
};

initDefaultPopups();

observer.subscribe('popup:refresh', (container) => {
    initDefaultPopups(container);
});

// Отдельный селектор для попапов обратных звонков
const popupFacadeLinks = Array.from(document.querySelectorAll('.j-popup-callback'));

if (popupFacadeLinks.length) {
    // Должен находиться выше подключения параметрического (на будущее)
    initCallbackPopup(popupFacadeLinks);
    popupFacadeLinks.forEach((element) => {
        element.dataset.init = 'true';
    });
}

// Отдельный селектор для попапов службы доверия
const popupTrustServiceFacadeLinks = Array.from(document.querySelectorAll('.j-popup-trust-service'));

if (popupTrustServiceFacadeLinks.length) {
    initTrustServicePopup(popupTrustServiceFacadeLinks);
}

// Шаг назад
const stepBackSelector = document.querySelector('.j-back');

if (stepBackSelector) {
    stepBack(stepBackSelector);
}

// Шеринг
const shareElements = Array.from(document.querySelectorAll('.j-share'));

if (shareElements.length) {
    initShare(shareElements);
}

// Кастомный слайдер swiper slider first-screen
const slidersCustom = Array.from(document.querySelectorAll('.j-swiper-slider-first-screen'));

slidersCustom.forEach((wrapper) => {
    initSwiperSlider({wrapper});
});

// Кастомный слайдер swiper slider vertical
const slidersVerticalCustom = Array.from(document.querySelectorAll('.j-swiper-vertical-slider'));

slidersVerticalCustom.forEach((wrapper) => {
    initSwiperVerticalSlider({wrapper});
});

// Кастомный слайдер swiper slider vertical
const sliderStepsCustom = Array.from(document.querySelectorAll('.j-swiper-acceptance-steps-slider'));

sliderStepsCustom.forEach((wrapper) => {
    initSwiperAcceptanceStepsSlider({wrapper});
});

// Кастомный слайдер swiper slider vertical
const slidersCarouselCustom = Array.from(document.querySelectorAll('.j-swiper-carousel-slider'));

slidersCarouselCustom.forEach((wrapper) => {
    initSwiperCarouselSlider({wrapper});
});

// Кастомный слайдер swiper slider vertical
const slidersCarouselOneItem = Array.from(document.querySelectorAll('.j-swiper-carousel-slider-one-item'));

slidersCarouselOneItem.forEach((wrapper) => {
    initSwiperCarouselSliderOneItem({wrapper});
});

// Кастомный слайдер swiper slider proposal advantages
const sliderProposalAdvantages = Array.from(document.querySelectorAll('.j-swiper-proposal-advantages'));

sliderProposalAdvantages.forEach((wrapper) => {
    initSwiperProposalAdvantages({wrapper});
});

observer.subscribe('swiper-carousel:refresh', (container) => {
    const slidersCarousel = Array.from(container.querySelectorAll('.j-swiper-carousel-slider'));
    const slides = Array.from(container.querySelectorAll('.j-slider-slides__slide-carousel'));
    const activeSlide = slides.findIndex((slide) => {
        return slide.classList.contains('is-active');
    });

    slidersCarousel.forEach((wrapper) => {
        initSwiperCarouselSlider({
            wrapper,
            initialSlide: activeSlide === -1 ? 0 : activeSlide
        });
    });
});

// Кастомный слайдер с зависимым слайдером
const slidersWrapperRelated = Array.from(document.querySelectorAll('.j-swiper-related'));

slidersWrapperRelated.forEach((wrapper) => {
    const mainWrapper = wrapper.querySelector('.j-swiper-related-main');
    const secondWrapper = wrapper.querySelector('.j-swiper-related-second');
    const isVertical = wrapper.dataset.vertical;
    const hasDynamicBg = wrapper.dataset.hasDynamicBg;

    if (!mainWrapper || !secondWrapper) {
        return;
    }

    initSwiperRelatedSlider({
        mainWrapper,
        secondWrapper,
        isVertical,
        hasDynamicBg,
        wrapper
    });
});

// Подскролл пунктов меню
const horizontalMenuElements = Array.from(document.querySelectorAll('.j-scroll-menu'));

horizontalMenuElements.forEach((horizontalMenu) => {
    initHorizontalMenu(horizontalMenu);
});

// Фикс vh для ios
if (slidersVerticalCustom.length || slidersWrapperRelated.length) {
    const events = ['resize', 'onorientationchange'];

    events.forEach((event) => {
        window.addEventListener(event, throttle(50, appHeight));
    });
}

// TODO: Переделать код нормально: есть ли необходимость подключать селекты отдельно от модуля в котором они должны работать?
const selectElements = Array.from(document.querySelectorAll('.j-custom-select.j-custom-select-independent'));

selectElements.forEach((element) => {
    const select = new CustomSelect({
        elem: element
    });

    select.init();
});

// Связанные селекты
const bindedSelects = Array.from(document.querySelectorAll('.j-custom-select.j-custom-select-dependent'));

initBindedSelects(bindedSelects[0], bindedSelects[1]);

// Дефолтные туглеры
const initTogglersDefault = (container) => {
    const wrapper = container ? container : document;
    const togglers = Array.from(wrapper.querySelectorAll('.j-toggle-wrapper'));

    togglers.forEach((toggler) => {
        initToggle({
            wrapper: toggler
        });
    });
};

initTogglersDefault();

observer.subscribe('toggle:refresh', (container) => {
    initTogglersDefault(container);
});

// Ход строительства
const progress = document.querySelector('.j-progress');

if (progress) {
    initProgress({
        wrapper: progress
    });
}

// Новости
const newsWrapper = document.querySelector('.j-news');

if (newsWrapper) {
    initNewsList({
        wrapper: newsWrapper
    });
}

// Кастомный слайдер swiper slider actions
const sliderActions = Array.from(document.querySelectorAll('.j-slider-actions'));

sliderActions.forEach((wrapper) => {
    initSwiperActionsSlider({wrapper});
});

// Кастомный слайдер swiper slider actions
const sliderFlats = Array.from(document.querySelectorAll('.j-flats-slider'));

sliderFlats.forEach((wrapper) => {
    initSwiperFlatsSlider({wrapper});
});

const purchaseTabs = Array.from(document.querySelectorAll('.j-tabs-purchase'));

purchaseTabs.forEach((tab) => {
    initTabs(tab);
});

const mortgageTabs = Array.from(document.querySelectorAll('.j-tabs-mortgage-wrap'));

mortgageTabs.forEach((tab) => {
    const options = {
        elem          : tab,
        tabsParent    : '.j-tabs-mortgage',
        tabItem       : '.j-tabs-mortgage__item',
        contentsParent: '.j-tabs-mortgage-content',
        contentItem   : '.j-tabs-mortgage-content__item'
    };

    initMortgageTabs(options);
});

// Слайдер при наведении в объектах
const objectsArray = Array.from(document.querySelectorAll('.j-object'));

objectsArray.forEach((wrapper) => {
    initObjectSlider({wrapper});
});

// Подключение параметрического
const parametricElements = Array.from(document.querySelectorAll('.j-parametric'));

parametricElements.forEach((element) => {
    initParametric({element});
});

// Подключение типовых квартир
const flatTypesElements = Array.from(document.querySelectorAll('.j-flat-type'));

flatTypesElements.forEach((element) => {
    initFlatType({element});
});

// Появление попапа с социальными сетями при клике по кнопке "Поделиться"
const buttonShareWrappers = [...document.querySelectorAll('.j-button-share-wrapper')];

if (buttonShareWrappers.length) {
    initButtonShare(buttonShareWrappers);
}

// Параллакс для галереи
const parallaxWrappers = Array.from(document.querySelectorAll('.j-column-parallax'));

parallaxWrappers.forEach((wrapper) => {
    initParallaxColumn(wrapper);
});


// Кнопки добавления в избранное
initFavoriteButton();

const favoriteListWrapper = document.querySelector('.j-favorites');

if (favoriteListWrapper) {
    initFavoritesList(favoriteListWrapper);
}

// Избранное в шапке сайта
const favoriteStates = [...document.querySelectorAll('.j-favorite-state')];

if (favoriteStates?.length) {
    favoriteStates.forEach((favoriteState) => {
        initFavoriteState(favoriteState);
    });
}

// Сравнение
const compareListWrapper = document.querySelector('.j-compares');

if (compareListWrapper) {
    initCompareList(compareListWrapper);
}

// Кнопки добавления в сравнение
initCompareButton();

// Сравнение в шапке сайта
const compareStates = [...document.querySelectorAll('.j-compare-state')];

if (compareStates.length) {
    compareStates.forEach((compareState) => {
        initCompareState(compareState);
    });
}

const slidersCompare = Array.from(document.querySelectorAll('.j-swiper-compare-slider'));
let compareSlider = null;

slidersCompare.forEach((wrapper) => {
    compareSlider = initSwiperComparelSlider({wrapper});
});

const slidersCompareSecond = Array.from(document.querySelectorAll('.j-swiper-compare-slider-second'));
let compareSecondSlider = null;

slidersCompareSecond.forEach((wrapper) => {
    compareSecondSlider = initSwiperComparelSlider({
        wrapper,
        initialSlide: 1
    });
});

observer.subscribe('compareSlider:refresh', () => {
    compareSlider.slider.update();
    compareSecondSlider.slider.update();
    compareSlider.slider.slideToClosest();
    compareSecondSlider.slider.slideToClosest();
});

initComparePopups();

// Уведомление об использовании кук
const cookiesWrapper = document.querySelector('.j-cookies-notice');

if (cookiesWrapper) {
    const cookies = new CookiesNotice();

    cookies.init(cookiesWrapper);
}

// Попап с информацией о куках
const cookiesButtons = Array.from(document.querySelectorAll('.j-cookies-popup'));

if (cookiesButtons.length) {
    const popupOptions = {
        openButtons         : cookiesButtons,
        closeButtonAriaLabel: 'Закрыть информацию',
        template            : 'classic',
        templateContent     : 'cookies',
        openLoadPage        : false
    };

    initPopup(cookiesButtons, popupOptions);
}

const visuals = [...document.querySelectorAll('.j-visual')];

if (visuals.length) {
    initPostMessagePopup();
}

const stickyButtons = document.querySelectorAll('.sticky-btn.j-popup');

stickyButtons.forEach((stickyButton) => {
    initStickyButton(stickyButton);
});

if (document.querySelector('section.opk')) {
    initOpkForm();
}

// initCombiningWidgets();

const promotionsTerms = document.querySelectorAll('.j-promotions-terms');

promotionsTerms.forEach((el) => {
    initPromotionTerms(el);
});

// Объединение виджетов обратного звонка
initCombiningWidgets();

initMindboxManager();
